import {AfterViewInit, Component, Input, OnDestroy, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {ReplaySubject} from 'rxjs';
import {UserPermissions} from '../../../../shared/interface/user-permissions';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {AuthService} from '../../../../shared/services/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {FilterService} from '../../../../shared/services/filter.service';
import {select, Store} from '@ngrx/store';
import {StoreRootState} from '../../../../shared/ngrx/reducers';
import {delay, distinctUntilChanged, takeUntil, tap} from 'rxjs/operators';
import {CountedAndPaginated} from '../../../../shared/interface/response/counted-and-paginated';
import {getCurrentRouteState} from '../../../../shared/ngrx/selector';
import {RouterStateUrl} from '../../../../shared/ngrx/route-serializer';
import {Uuid} from '../../../../shared/interface/response/uuid';
import {JobResultDialogComponent} from '../../../../shared/components/job-result-dialog/job-result-dialog.component';
import {HttpErrorResponse} from '@angular/common/http';
import {Invoice} from '../../../../shared/interface/invoice';
import {InvoiceService} from '../../../../shared/services/invoice.service';
import {PaymentService} from '../../../../shared/services/payment.service';
import {CommissionJob} from "../../../../shared/interface/commission-job";

@Component({
  selector: 'app-payment-history',
  templateUrl: './payment-history.component.html',
  styleUrls: ['./payment-history.component.scss']
})
export class PaymentHistoryComponent implements OnDestroy, AfterViewInit {
  @ViewChild('filtersForm') filtersForm: NgForm;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Input() statusKey?: string[] = null;

  initialFilters: any;
  items: Invoice[] = [];
  totalData = 0;
  displayedColumns: string[] = [
    'billingMonth', 'description', 'createdAt', 'createdBy', 'actions'
  ];
  userPermissions: ReplaySubject<UserPermissions>;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private invoiceService: InvoiceService,
    private paymentService: PaymentService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
    private activatedRoute: ActivatedRoute,
    private filterService: FilterService,
    private store: Store<StoreRootState>,
    private router: Router,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.invoiceService.invoiceListSubject
      .pipe(
        takeUntil(this.destroyed$),
        tap((e: CountedAndPaginated<Invoice>) => {
          this.items = e.items;
          this.totalData = e.pagination.total;
        })
      ).subscribe();
    this.parseFilters();
  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      billingMonth: 'date',
      contains$number: 'string',
      ofwca: 'string',
      partner: 'string',
      in$status: 'int[]',
      gte$net: 'string',
      lte$net: 'string',
      assetsRegional: 'string',
    }, filters);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  ngAfterViewInit(): void {
    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: event.pageIndex,
        pageSize: event.pageSize,
        ...this.filtersForm.value
      })]);
    });

    this.store
      .pipe(
        select(getCurrentRouteState),
        delay(0),
        distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
        takeUntil(this.destroyed$),
      )
      .subscribe((state: RouterStateUrl) => {
        this.parseFilters(state.params);
        this.paginator.pageIndex = state.params.page;
        this.paginator.pageSize = state.params.pageSize;
        this.loadListData();
      })
    ;
  }

  filter(): void {
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
      page: 0,
      pageSize: this.paginator.pageSize,
      ...this.filtersForm.value,
    })]);
  }
  buildFilters(): any {
    const filters = {...this.initialFilters};

    if (null !== this.statusKey) {
      filters.statusKey = this.statusKey;
    }
    return filters;
  }
  loadListData(): void {
    this.paymentService.loadPaymentList(this.paginator.pageIndex, this.paginator.pageSize, this.buildFilters());
  }

  downloadReport(): void {
    this.invoiceService.downloadReport(this.initialFilters)
      .subscribe((response: Uuid) => {
        this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
      page: 0,
      pageSize: this.paginator.pageSize,
    }]);
  }
  onImgError($event: ErrorEvent): void {
    // @ts-ignore
    $event.target.src = '/assets/avatar.png';
  }
  downloadReportFile(commissionJob: CommissionJob): void {
    this.invoiceService.downloadReport({job: commissionJob.uuid})
      .subscribe((response: Uuid) => {
        this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }

}
